export const MAP_BUILDER_VERSION = '0.0.9';
